module.exports = __webpack_public_path__ + "static/banner-footer-1bd11148069acfe16177a93e8affaf47.jpg";